<div class="grid">
<div class="col-12 md:col-12 lg:col-12">
  <div class="recuadro-widget" style="width: 100%">
    <span class="recuadro-widget-icon bg-green"><i class="fa fa-user-o"></i></span>

    <div class="recuadro-widget-content">
      <span class="recuadro-widget-number">{{datWidget.numerador}}/{{datWidget.denominador}}</span>
      <span class="recuadro-widget-text">{{'WIDGETS.LBL_WIDGETCARGO' | translate }}</span>
      <div class="col-12 lg:col-12 md:col-12">
        <div class="col-12 text-center" *ngIf="actCargos">
          <i class="fa fa-refresh fa-spin"></i>  <span><strong>{{'LBL_PROCESANDO' | translate }}</strong></span>
        </div>
      </div>
    </div>
    <!-- /.info-box-content -->
  </div>
  <!-- /.info-box -->
</div>
</div>
